import React, {useContext, useEffect, useState} from 'react';
import './PromoItem.css';

import {Drawer} from "@material-ui/core";
import CasesView from "../CasesView";
import {IPromoSectionData, ISection} from "../../model/B2CInfo";
import {trackGoal} from "../../../helpers/tracker";
import close from "../../../imgs/close.png";
import {ISession} from "../../../networking/Options";

interface IPromoItemProps {
    section: ISection
    session?: ISession
}

export const localStorageKey = "show_chat_after_login";

export default function PromoItem(props: IPromoItemProps) {

    const [state, setState] = useState(false);
    const sectionData = (props.section.data as IPromoSectionData);

    const iframeSrc = "https://yandex.ru/drive/web/index.html";
    const isUserRegistered = props.session?.user.details.status !== "onboarding" && props.session != null;
    const showChat = !isUserRegistered;
    const isLoggedIn = props.session != null;

    const registerButtonTitle = isUserRegistered ? "Скачать Драйв" : sectionData.button_title;
    const registerButtonSubtitle = isUserRegistered ? null : sectionData.button_subtitle;

    useEffect(() => {
        const item = window.localStorage.getItem(localStorageKey);
        if (item === "true" && showChat) {
            setState(true);
        }
        window.localStorage.removeItem(localStorageKey);
    }, []);

    return <div className="PromoContainer">
        <div className="PromoContent">
            {/*<MenuRow/>*/}
            <div className="Promo_Item_Left_Section">
                <div className="Promo_Item_Left_Section_Title">{sectionData.title}</div>
                <React.Fragment key="right">
                    <button className="RegisterButton" onClick={(e) => {
                        if (!isLoggedIn) {
                            window.localStorage.setItem(localStorageKey, "true");
                            window.open(`https://passport.yandex.ru/auth?origin=driveb2c&retpath=${window.location.href}`)
                            return;
                        }

                        if (showChat) {
                            setState(true);
                        } else {
                            window.document
                                .querySelector(`#app_promo`)
                                ?.scrollIntoView({behavior: "smooth", block: "start"})
                        }
                        trackGoal("tap_register");
                    }
                    }>
                        <div className="RegisterButtonTitle">{registerButtonTitle}</div>
                        {
                            registerButtonSubtitle && <div className="RegisterButtonSubtitle">{registerButtonSubtitle}</div>
                        }
                    </button>
                    <Drawer anchor="right" open={state} onClose={(e) => setState(false)}>
                        <div style={{width: "500px", backgroundColor: "#ffffff", border: "none"}}>
                            <div className="Promo_Item_Right_Section">
                                <div className="Promo_Item_Right_Section_NavBar">
                                    <span className="Promo_Item_Right_Section_NavBar_Title">Регистрация в Драйве</span>
                                    <img className="Promo_Item_Right_Section_NavBar_Close" src={close}
                                         onClick={(e) => setState(false)}/>
                                </div>
                                <iframe src={iframeSrc} style={{
                                    height: "100vh",
                                    width: "100%",
                                    position: "absolute",
                                    zIndex: 99,
                                    backgroundColor: "#ffffff",
                                    border: "none"
                                }}/>
                            </div>
                        </div>
                    </Drawer>
                </React.Fragment>
            </div>
            <div style={{position: "absolute", width: "256px", right: "227px", top: "0px"}}>
                <CasesView cases={
                    sectionData.features.map((feature) => {
                        return {title: feature.name, icon: feature.icon};
                    })
                }/>
            </div>
        </div>
    </div>;


}